export default {
  colors: {
    text: '#33ff33',
    background: '#0a0a0a',
    primary: '#33ff33',
    secondary: '#ffb000',
    accent: '#00d4ff',
    muted: '#1a1a2e',
    highlight: '#ffb000',
    modes: {
      amber: {
        text: '#ffb000',
        primary: '#ffb000',
        secondary: '#33ff33',
      }
    }
  },
  fonts: {
    body: '"JetBrains Mono", "IBM Plex Mono", monospace',
    heading: '"Press Start 2P", monospace',
    monospace: '"JetBrains Mono", monospace',
  },
  fontSizes: [12, 14, 16, 20, 24, 32, 48],
  lineHeights: { body: 1.7, heading: 1.4 },
  styles: {
    root: {
      fontFamily: 'body',
      color: 'text',
      bg: 'background',
    }
  }
}
